import React from "react";
import { motion } from "framer-motion";
import { CheckIcon, GlobeIcon, DownloadIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { CountdownTimer } from "./CountdownTimer";
import { ScarcityBar } from "./ScarcityBar";
const rows = [{
  label: "Sistema Antirrefinamientos™",
  value: "USD $97"
}, {
  label: "Los 6 Tomos Clínicos",
  value: "Incluido"
}, {
  label: "Más de 300 Protocolos y Checklists",
  value: "Incluido"
}, {
  label: "Biblioteca de Protocolos de Rescate",
  value: "Incluido"
}, {
  label: "Matrices de Predictibilidad",
  value: "Incluido"
}, {
  label: "Árboles de Decisión Clínica",
  value: "Incluido"
}, {
  label: "Los 5 Bonos Exclusivos",
  value: "USD $185"
}];
export function Offer() {
  return <section id="oferta" className="bg-navy-800 px-5 py-12" data-id="element-116" data-mp="z00yxbcme58b">
      <div className="mx-auto max-w-md" data-id="element-117" data-mp="2fb50iwvph46l">
        <div className="text-center" data-id="element-118" data-mp="2feakjxph9fvg">
          <div className="mb-2 text-2xl" data-id="element-119" data-mp="2admq1221igwh">💰</div>
          <h2 className="font-display text-2xl font-extrabold text-white sm:text-3xl" data-id="element-120" data-mp="2actku5iqbzgg">Oferta Especial</h2>
          <p className="mt-2 text-sm text-white/60" data-id="element-121" data-mp="pmbgpus6v45i">Todo lo que recibirás hoy</p>
        </div>

        <div className="mt-6 overflow-hidden rounded-2xl bg-white" data-id="element-122" data-mp="uleovo3gtqhp">
          <div className="flex items-center justify-between bg-navy-50 px-4 py-2.5 text-[11px] font-bold uppercase tracking-wide text-navy-800/60" data-id="element-123" data-mp="zjpypytrg0zx">
            <span data-id="element-124" data-mp="6tpqpr3yq7su">Incluye</span>
            <span data-id="element-125" data-mp="6uipa4srpqzw">Valor referencial</span>
          </div>
          {rows.map(r => <div key={r.label} className="flex items-center justify-between gap-3 border-b border-navy-50 px-4 py-3 last:border-0" data-id="element-126" data-mp="bsasvw2rz1jx">
              <span className="flex items-start gap-2 text-sm font-medium text-navy-800" data-id="element-127" data-mp="fskyv8qkhrys">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" data-id="element-128" data-mp="kmyw7gosi963" />
                {r.label}
              </span>
              <span className={`shrink-0 text-sm font-bold ${r.value === "Incluido" ? "text-brand" : "text-navy-800/50 line-through"}`} data-id="element-129" data-mp="3o9z9jc3awkd6">
                {r.value}
              </span>
            </div>)}
          <div className="flex items-center justify-between bg-navy-50 px-4 py-3" data-id="element-130" data-mp="qetehoe3ggq6">
            <span className="text-sm font-bold text-navy-800" data-id="element-131" data-mp="157mvxfcxf6xh">Valor Referencial Total</span>
            <span className="font-display text-lg font-extrabold text-navy-800/50 line-through" data-id="element-132" data-mp="1078x8nx7t9c4">USD $282</span>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="mt-6 rounded-2xl border-2 border-brand bg-white p-6 text-center shadow-2xl" data-id="element-133" data-mp="7i1q50jp3bf9">
          <p className="text-sm text-navy-800/60" data-id="element-134" data-mp="heo91jsgnsen">
            Hoy no pagarás <s data-id="element-135" data-mp="1wvoqatzja0tz">USD $282</s> ni <s data-id="element-136" data-mp="1wv54h26risao">USD $97</s>
          </p>
          <p className="mt-3 text-xs font-semibold uppercase tracking-wide text-navy-800/50" data-id="element-137" data-mp="1sv4tjrivgz8d">
            Acceso inmediato por solo
          </p>
          <div className="my-1 font-display text-6xl font-extrabold leading-none text-brand" data-id="element-138" data-mp="20duj1yi63zgr">
            USD&nbsp;$15
          </div>
          <p className="text-xs font-medium text-navy-800/60" data-id="element-139" data-mp="25bnogpbncpfz">
            Pago único • Sin mensualidades • Acceso de por vida
          </p>

          <div className="my-6 border-t border-dashed border-navy-100 pt-6" data-id="element-140" data-mp="1vf16q9emaei6">
            <CtaButton data-id="element-141" data-mp="2j55acgrt2e96">Quiero el Sistema Antirrefinamientos™</CtaButton>
            <div className="mt-3 flex items-center justify-center gap-1.5 text-xs font-semibold text-navy-800/70" data-id="element-142" data-mp="2j787rlvaf9nx">
              <DownloadIcon className="h-4 w-4 text-brand" data-id="element-143" data-mp="2o62qyox6308k" />
              Descarga inmediata
            </div>
          </div>

          <CountdownTimer data-id="element-144" data-mp="2edwv343snyo3" />

          <div className="mt-6" data-id="element-145" data-mp="2ed3wwriwihhk">
            <ScarcityBar data-id="element-146" data-mp="2ec2bbt49ecll" />
          </div>

          <div className="mt-4 flex items-start justify-center gap-2 rounded-xl bg-navy-50 p-3 text-left text-xs text-navy-800/70" data-id="element-147" data-mp="323r75jgahj7a">
            <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" data-id="element-148" data-mp="36wap0sm0f0hw" />
            <span data-id="element-149" data-mp="1j7frmx00xtin">
              El <strong className="text-navy-800" data-id="element-150" data-mp="1j7zaqh1euny9">cambio de moneda es automático</strong>: pagas el
              equivalente a USD $15 en tu moneda local sin conversiones manuales.
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}